import type React from 'react'

import { removeProtocolFromUrl } from '@/helpers'
import css from './URL.module.scss'

type Props = {
  url: string
  onRedirect: () => void
}

const URL: React.FC<Props> = ({ url, onRedirect }) => {
  const handleRedirect = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    onRedirect()
  }

  return (
    <div className={css.container} onClick={handleRedirect}>
      <div className={css.url}>{removeProtocolFromUrl(url)}</div>
    </div>
  )
}

export default URL
